(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["style-shopping-guide"] && !Shopify.designMode) return;
  try {
    
    if(window.matchMedia("(min-width: 769px)")) {
      let guideSection = document.querySelectorAll('#rightContents .guideSection');
      "scroll resize load".split(" ").forEach(function(e){
          for (let i = 0 ; i < guideSection.length ; i++){
            window.addEventListener(e, function() {
                const callback = (entries) => {
                  entries.forEach( (entry) => {
                    let id = entry.target.getAttribute('id');
                    if(entry.isIntersecting) {
                      document.querySelector("[data-target='" + id + "']").classList.add('is-visible');
                    } else {
                      document.querySelector("[data-target='" + id + "']").classList.remove('is-visible');
                    }
                  });
                }
                const options = {
                  root: null,
                  rootMargin: ' -8.99% 0px -91%',
                  threshold: 0
                }
                const observer = new IntersectionObserver( callback, options );
                let target = guideSection[i];
                observer.observe(target);
            });
          }
      });
    }
  

  } catch(e) { console.error(e); }
})();
})();
